module.exports = __webpack_public_path__ + "img/login3.d908c08c.gif";